function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { registerMethods } from '../../utils/methods.js';
import { filter, map } from '../../utils/utils.js';
// Store data values on svg nodes
export function data(a, v, r) {
    if (a == null) {
        // get an object of attributes
        return this.data(map(filter(this.node.attributes, function(el) {
            return el.nodeName.indexOf('data-') === 0;
        }), function(el) {
            return el.nodeName.slice(5);
        }));
    } else if (_instanceof(a, Array)) {
        var _$data = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                _$data[key] = this.data(key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$data;
    } else if ((typeof a === "undefined" ? "undefined" : _type_of(a)) === 'object') {
        for(v in a){
            this.data(v, a[v]);
        }
    } else if (arguments.length < 2) {
        try {
            return JSON.parse(this.attr('data-' + a));
        } catch (e) {
            return this.attr('data-' + a);
        }
    } else {
        this.attr('data-' + a, v === null ? null : r === true || typeof v === 'string' || typeof v === 'number' ? v : JSON.stringify(v));
    }
    return this;
}
registerMethods('Dom', {
    data: data
});
